/* tslint:disable */
import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from "@angular/common/http";
import { BaseService as __BaseService } from "../base-service";
import { ApiConfiguration as __Configuration } from "../api-configuration";
import { StrictHttpResponse as __StrictHttpResponse } from "../strict-http-response";
import { Observable as __Observable } from "rxjs";
import { map as __map, filter as __filter } from "rxjs/operators";

import { AdmGroupEx } from "../models/adm-group-ex";
import { AdmLayoutLite } from "../models/adm-layout-lite";
@Injectable({
  providedIn: "root",
})
class AdminAdmGroupService extends __BaseService {
  static readonly adminAdmGroupGetGroupsPath = "/api/AdminAdmGroup/Groups";
  static readonly adminAdmGroupSaveGroupPath = "/api/AdminAdmGroup/SaveGroup";
  static readonly adminAdmGroupDeleteGroupPath =
    "/api/AdminAdmGroup/DeleteGroup/{groupId}";
  static readonly adminAdmGroupGetPlanTypeGroupsPath =
    "/api/AdminAdmGroup/PlanTypeGroups/{interactSubTypeId}";
  static readonly adminAdmGroupSetPlanTypeGroupsPath =
    "/api/AdminAdmGroup/PlanTypeGroups/{interactSubTypeId}";
  static readonly adminAdmGroupGetSubscriptionAdmsPath =
    "/api/AdminAdmGroup/SubscriptionAdms";
  static readonly adminAdmGroupGetPlanTypeAllowSelfServiceCreatePath =
    "/api/AdminAdmGroup/PlanTypeAllowSelfServiceCreate/{interactSubTypeId}";
  static readonly adminAdmGroupSetPlanTypeAllowSelfServiceCreatePath =
    "/api/AdminAdmGroup/PlanTypeAllowSelfServiceCreate/{interactSubTypeId}";
  static readonly adminAdmGroupGetPlanTypeAdmLayoutsPath =
    "/api/AdminAdmGroup/PlanTypeAdmLayouts/{interactSubTypeId}";
  static readonly adminAdmGroupSetPlanTypeAdmLayoutsPath =
    "/api/AdminAdmGroup/PlanTypeAdmLayouts/{interactSubTypeId}";

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }
  adminAdmGroupGetGroupsResponse(): __Observable<
    __StrictHttpResponse<Array<AdmGroupEx>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/AdminAdmGroup/Groups`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<AdmGroupEx>>;
      })
    );
  }
  adminAdmGroupGetGroups(): __Observable<Array<AdmGroupEx>> {
    return this.adminAdmGroupGetGroupsResponse().pipe(
      __map((_r) => _r.body as Array<AdmGroupEx>)
    );
  }

  /**
   * @param request undefined
   */
  adminAdmGroupSaveGroupResponse(
    request: AdmGroupEx
  ): __Observable<__StrictHttpResponse<number>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/AdminAdmGroup/SaveGroup`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({
          body: parseFloat((_r as HttpResponse<any>).body as string),
        }) as __StrictHttpResponse<number>;
      })
    );
  }
  /**
   * @param request undefined
   */
  adminAdmGroupSaveGroup(request: AdmGroupEx): __Observable<number> {
    return this.adminAdmGroupSaveGroupResponse(request).pipe(
      __map((_r) => _r.body as number)
    );
  }

  /**
   * @param groupId undefined
   */
  adminAdmGroupDeleteGroupResponse(
    groupId: number
  ): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/AdminAdmGroup/DeleteGroup/${groupId}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "blob",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param groupId undefined
   */
  adminAdmGroupDeleteGroup(groupId: number): __Observable<Blob> {
    return this.adminAdmGroupDeleteGroupResponse(groupId).pipe(
      __map((_r) => _r.body as Blob)
    );
  }

  /**
   * @param interactSubTypeId undefined
   */
  adminAdmGroupGetPlanTypeGroupsResponse(
    interactSubTypeId: number
  ): __Observable<__StrictHttpResponse<Array<number>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/AdminAdmGroup/PlanTypeGroups/${interactSubTypeId}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<number>>;
      })
    );
  }
  /**
   * @param interactSubTypeId undefined
   */
  adminAdmGroupGetPlanTypeGroups(
    interactSubTypeId: number
  ): __Observable<Array<number>> {
    return this.adminAdmGroupGetPlanTypeGroupsResponse(interactSubTypeId).pipe(
      __map((_r) => _r.body as Array<number>)
    );
  }

  /**
   * @param params The `AdminAdmGroupService.AdminAdmGroupSetPlanTypeGroupsParams` containing the following parameters:
   *
   * - `interactSubTypeId`:
   *
   * - `groupIds`:
   */
  adminAdmGroupSetPlanTypeGroupsResponse(
    params: AdminAdmGroupService.AdminAdmGroupSetPlanTypeGroupsParams
  ): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.groupIds;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl +
        `/api/AdminAdmGroup/PlanTypeGroups/${params.interactSubTypeId}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "blob",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param params The `AdminAdmGroupService.AdminAdmGroupSetPlanTypeGroupsParams` containing the following parameters:
   *
   * - `interactSubTypeId`:
   *
   * - `groupIds`:
   */
  adminAdmGroupSetPlanTypeGroups(
    params: AdminAdmGroupService.AdminAdmGroupSetPlanTypeGroupsParams
  ): __Observable<Blob> {
    return this.adminAdmGroupSetPlanTypeGroupsResponse(params).pipe(
      __map((_r) => _r.body as Blob)
    );
  }
  adminAdmGroupGetSubscriptionAdmsResponse(): __Observable<
    __StrictHttpResponse<Array<AdmLayoutLite>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/AdminAdmGroup/SubscriptionAdms`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<AdmLayoutLite>>;
      })
    );
  }
  adminAdmGroupGetSubscriptionAdms(): __Observable<Array<AdmLayoutLite>> {
    return this.adminAdmGroupGetSubscriptionAdmsResponse().pipe(
      __map((_r) => _r.body as Array<AdmLayoutLite>)
    );
  }

  /**
   * @param interactSubTypeId undefined
   */
  adminAdmGroupGetPlanTypeAllowSelfServiceCreateResponse(
    interactSubTypeId: number
  ): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl +
        `/api/AdminAdmGroup/PlanTypeAllowSelfServiceCreate/${interactSubTypeId}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({
          body: (_r as HttpResponse<any>).body === "true",
        }) as __StrictHttpResponse<boolean>;
      })
    );
  }
  /**
   * @param interactSubTypeId undefined
   */
  adminAdmGroupGetPlanTypeAllowSelfServiceCreate(
    interactSubTypeId: number
  ): __Observable<boolean> {
    return this.adminAdmGroupGetPlanTypeAllowSelfServiceCreateResponse(
      interactSubTypeId
    ).pipe(__map((_r) => _r.body as boolean));
  }

  /**
   * @param params The `AdminAdmGroupService.AdminAdmGroupSetPlanTypeAllowSelfServiceCreateParams` containing the following parameters:
   *
   * - `interactSubTypeId`:
   *
   * - `allow`:
   */
  adminAdmGroupSetPlanTypeAllowSelfServiceCreateResponse(
    params: AdminAdmGroupService.AdminAdmGroupSetPlanTypeAllowSelfServiceCreateParams
  ): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.allow;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl +
        `/api/AdminAdmGroup/PlanTypeAllowSelfServiceCreate/${params.interactSubTypeId}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "blob",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param params The `AdminAdmGroupService.AdminAdmGroupSetPlanTypeAllowSelfServiceCreateParams` containing the following parameters:
   *
   * - `interactSubTypeId`:
   *
   * - `allow`:
   */
  adminAdmGroupSetPlanTypeAllowSelfServiceCreate(
    params: AdminAdmGroupService.AdminAdmGroupSetPlanTypeAllowSelfServiceCreateParams
  ): __Observable<Blob> {
    return this.adminAdmGroupSetPlanTypeAllowSelfServiceCreateResponse(
      params
    ).pipe(__map((_r) => _r.body as Blob));
  }

  /**
   * @param interactSubTypeId undefined
   */
  adminAdmGroupGetPlanTypeAdmLayoutsResponse(
    interactSubTypeId: number
  ): __Observable<__StrictHttpResponse<Array<number>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl +
        `/api/AdminAdmGroup/PlanTypeAdmLayouts/${interactSubTypeId}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<number>>;
      })
    );
  }
  /**
   * @param interactSubTypeId undefined
   */
  adminAdmGroupGetPlanTypeAdmLayouts(
    interactSubTypeId: number
  ): __Observable<Array<number>> {
    return this.adminAdmGroupGetPlanTypeAdmLayoutsResponse(
      interactSubTypeId
    ).pipe(__map((_r) => _r.body as Array<number>));
  }

  /**
   * @param params The `AdminAdmGroupService.AdminAdmGroupSetPlanTypeAdmLayoutsParams` containing the following parameters:
   *
   * - `interactSubTypeId`:
   *
   * - `admLayoutIds`:
   */
  adminAdmGroupSetPlanTypeAdmLayoutsResponse(
    params: AdminAdmGroupService.AdminAdmGroupSetPlanTypeAdmLayoutsParams
  ): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.admLayoutIds;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl +
        `/api/AdminAdmGroup/PlanTypeAdmLayouts/${params.interactSubTypeId}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "blob",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param params The `AdminAdmGroupService.AdminAdmGroupSetPlanTypeAdmLayoutsParams` containing the following parameters:
   *
   * - `interactSubTypeId`:
   *
   * - `admLayoutIds`:
   */
  adminAdmGroupSetPlanTypeAdmLayouts(
    params: AdminAdmGroupService.AdminAdmGroupSetPlanTypeAdmLayoutsParams
  ): __Observable<Blob> {
    return this.adminAdmGroupSetPlanTypeAdmLayoutsResponse(params).pipe(
      __map((_r) => _r.body as Blob)
    );
  }
}

module AdminAdmGroupService {
  /**
   * Parameters for AdminAdmGroupSetPlanTypeGroups
   */
  export interface AdminAdmGroupSetPlanTypeGroupsParams {
    interactSubTypeId: number;
    groupIds: Array<number>;
  }

  /**
   * Parameters for AdminAdmGroupSetPlanTypeAllowSelfServiceCreate
   */
  export interface AdminAdmGroupSetPlanTypeAllowSelfServiceCreateParams {
    interactSubTypeId: number;
    allow: boolean;
  }

  /**
   * Parameters for AdminAdmGroupSetPlanTypeAdmLayouts
   */
  export interface AdminAdmGroupSetPlanTypeAdmLayoutsParams {
    interactSubTypeId: number;
    admLayoutIds: Array<number>;
  }
}

export { AdminAdmGroupService };
